import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

export default function SessionAlertDialog({
  open,
  onClose,
  onConfirm,
  onCancel,
  title,
  description,
  confirmText,
  cancelText,
  details,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: "rgba(0,0,0,0.7)",
          color: "white",
          px: 4,
          py: 3,
          borderRadius: 3,
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: "center",
          fontWeight: 600,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
        }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 36, color: "#fff" }} />
        {title}
      </DialogTitle>

      <DialogContent>
        <Typography
          sx={{
            textAlign: "center",
            fontSize: 14,
            color: "#ddd",
            mt: 1,
          }}
        >
          {description}
        </Typography>
        {details && (
          <Typography
            component="div"
            sx={{
              mt: 2,
              px: 2,
              py: 1.5,
              borderRadius: 2,
              backgroundColor: "rgba(255,255,255,0.08)",
              border: "1px solid rgba(255,255,255,0.14)",
              color: "#fff",
            }}
          >
            {details}
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2, gap: 2 }}>
        <Button
          onClick={onConfirm}
          sx={{
            color: "#76ff03",
            fontWeight: 600,
            "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
          }}
        >
          {confirmText}
        </Button>
        {cancelText && (
          <Button
            onClick={onCancel || onClose}
            sx={{
              color: "#9e9e9e",
              fontWeight: 600,
              "&:hover": { color: "#f44336" },
            }}
          >
            {cancelText}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
